import React, { useState } from "react";
import "../css2/NameThreeThings.css";

export default function NameThreeThings() {
  const steps = [
    {
      id: "see",
      title: "Name 3 Things You Can See",
      prompt: "Look around. What 3 objects do you notice?",
      icon: "👁️",
    },
    {
      id: "hear",
      title: "Name 3 Things You Can Hear",
      prompt: "Pause. What sounds are present right now?",
      icon: "👂",
    },
    {
      id: "feel",
      title: "Name 3 Things You Can Feel",
      prompt: "Notice sensations. What do you physically feel?",
      icon: "🤲",
    },
  ];

  const [step, setStep] = useState(0);
  const [finished, setFinished] = useState(false);

  const [answers, setAnswers] = useState([
    ["", "", ""], // see
    ["", "", ""], // hear
    ["", "", ""], // feel
  ]);

  const currentStep = steps[step];
  const currentAnswers = answers[step];

  const updateAnswer = (i, value) => {
    const updated = [...answers];
    updated[step][i] = value;
    setAnswers(updated);
  };

  const isFilled = currentAnswers.every((a) => a.trim() !== "");

  const goNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      // Final step completed → show finish screen
      setFinished(true);
    }
  };

  if (finished) {
    const flatAnswers = answers.flat();

    return (
      <div className="n3-finish-bg">
        <div className="n3-finish-card fade-in">
          <div className="n3-checkmark">
            <div className="circle"></div>
            <div className="check"></div>
          </div>

          <h2 className="n3-finish-title">You’re back in the moment ✨</h2>
          <p className="n3-finish-sub">Here’s what you noticed around you:</p>

          <div className="n3-answer-list">
            {flatAnswers.map((ans, i) => (
              <div key={i} className="n3-answer-item">
                <span>{ans}</span>
              </div>
            ))}
          </div>

          <button
            className="n3-finish-button"
            onClick={() => window.history.back()}
          >
            Back to Safety 💛
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="n3-bg">
      <div className="n3-card fade-in">
        <h2 className="n3-title">{currentStep.title}</h2>
        <p className="n3-description">{currentStep.prompt}</p>

        <div className="n3-input-group">
          {currentAnswers.map((v, i) => (
            <div className="n3-input-wrapper" key={i}>
              <span className="n3-input-icon">{currentStep.icon}</span>
              <input
                className="n3-input"
                placeholder={`Thing ${i + 1}`}
                value={v}
                onChange={(e) => updateAnswer(i, e.target.value)}
              />
            </div>
          ))}
        </div>

        <button
          className={`n3-button ${isFilled ? "active" : ""}`}
          onClick={goNext}
        >
          {step === steps.length - 1 ? "Finish" : "Next →"}
        </button>

        <div className="n3-dots">
          {steps.map((_, idx) => (
            <div
              key={idx}
              className={`n3-dot ${idx === step ? "active" : ""}`}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
}
